export const types = {
    SESSION_REPLACE_ALL: 'SESSION_REPLACE_ALL',
    SESSION_SET_PARAMETERS: 'SESSION_SET_PARAMETERS',
    SESSION_SET_SIGNED_WEB_SOCKET_URL: 'SESSION_SET_SIGNED_WEB_SOCKET_URL',
    SESSION_TOGGLE_NAVIGATION_LOCK: 'SESSION_TOGGLE_NAVIGATION_LOCK',
    NAVIGATOR_SET_OFFLINE_STATE: 'NAVIGATOR_SET_OFFLINE_STATE',
    SESSION_TOGGLE_INVIGILATOR_AUTHORIZED: 'SESSION_TOGGLE_INVIGILATOR_AUTHORIZED',
    TIME_SET_TIME_REMAINING: 'SESSION_SET_TIME_REMAINING',
    TIME_SET_TIME_REMAINING_FETCHED_FROM_SERVER: 'SESSION_SET_TIME_REMAINING_FETCHED_FROM_SERVER',
    TIME_SET_LAST_MINUTES_MODE: 'SESSION_SET_LAST_MINUTES_MODE',
};

export const setParameters = (parameters) => {
    return { type: types.SESSION_SET_PARAMETERS, parameters };
};
export const parameterSetter = (paramName, defaultValue) => (paramValue) => {
    let value = paramValue;
    if (value === undefined && defaultValue !== undefined) {
        value = defaultValue;
    }

    return setParameters({ [paramName]: value });
};

const sessionActions = {
    types,

    toggleNavigationLock(isLocked, reason, owner, enablePauseMode) {
        return { type: types.SESSION_TOGGLE_NAVIGATION_LOCK, navigationLock: { isLocked, reason, owner, enablePauseMode } };
    },

    setNavigatorOfflineState(isOffline) {
        return { type: types.NAVIGATOR_SET_OFFLINE_STATE, isNavigatorOffline: isOffline };
    },

    toggleInvigilatorAuthorized(isAuthorized) {
        return { type: types.SESSION_TOGGLE_INVIGILATOR_AUTHORIZED, invigilatorAuthorized: isAuthorized };
    },

    replaceAll(parameters) {
        return { type: types.SESSION_REPLACE_ALL, parameters };
    },

    setSignedWebSocketUrl: (signedWebSocketUrl) => {
        return { type: types.SESSION_SET_SIGNED_WEB_SOCKET_URL, signedWebSocketUrl };
    },

    setQuestionSetIdentifier: (paramName, paramValue) => setParameters({ questionSetIdentifier: { paramName, paramValue } }),

    setChildTestIdentifiers: parameters => setParameters(parameters),

    unsetChildTestIdentifiers: () => setParameters({
        childTestIdentifier: undefined,
        childContext: undefined,
        childResumed: undefined,
        childSessionInfo: undefined,
    }),

    setAppReady: parameterSetter('appReady', true),
    setCriticalErrorOccurred: parameterSetter('criticalErrorOccurred', true),
    setChromeExtensionId: parameterSetter('chromeExtensionId'),
    setContext: parameterSetter('context'),
    setDebugParams: parameterSetter('debugParams'),
    setIsLoggedIn: parameterSetter('isLoggedIn', true),
    setLanguage: parameterSetter('language'),
    setMode: parameterSetter('mode'),
    setHypothesisSidebarOpen: parameterSetter('hypothesisSidebarOpen'),
    setAnnotationsSidebarOpen: parameterSetter('annotationsSidebarOpen'),
    setChatSidebarOpen: parameterSetter('chatSidebarOpen'),
    setPrintParams: parameterSetter('printParams'),
    setLayoutParams: parameterSetter('layoutParams'),
    setRequestParameterIds: parameterSetter('requestParameterIds'),
    setResumed: parameterSetter('resumed'),
    setChildResumed: parameterSetter('childResumed'),
    setResumedTestAfterPassword: parameterSetter('resumedTestAfterPassword'),
    setSessionInfo: parameterSetter('sessionInfo'),
    setChildSessionInfo: parameterSetter('childSessionInfo'),
    setViewMedia: parameterSetter('viewMedia'),
    setCatTriggerInProgress: parameterSetter('catTriggerInProgress'),
};

export default sessionActions;
